export class TenantConfig {
    name: string;
    dns: string;
    businessPlan: string;
}

export class TenantConfigRes {
    name: string;
    dns: string;
    businessPlan: string;
    user: string;
    created: string;
}

export class ConfigPair {
    public key: string;
    public val: string;

    constructor(key: string, val: string) {
        this.key = key;
        this.val = val;
    }
}

export class ConfigPairList {
    configPairs : ConfigPair[];
}

export class TenantBusinessPlans{
    plan_en: string;
    plan_it: string;
}

export const TENANT_BUSINESS_PLANS : TenantBusinessPlans[] = [
    {plan_en: 'Basic', plan_it:'Di base'},
    {plan_en: 'Standard', plan_it:'Standard'},
    {plan_en: 'Premium', plan_it:'Premium'}
]
